namespace GeniuzPOS.InitialData {
    export interface PsCashCouponTypeForm {
        CashCouponType: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        CashCouponName: Serenity.StringEditor;
        CashCouponValueType: Serenity.EnumEditor;
        CashCouponValue: Serenity.DecimalEditor;
        PartnerCompensatePc: Serenity.DecimalEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
    }

    export class PsCashCouponTypeForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCashCouponType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCashCouponTypeForm.init)  {
                PsCashCouponTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DateEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.ImageUploadEditor;

                Q.initFormType(PsCashCouponTypeForm, [
                    'CashCouponType', w0,
                    'IsActive', w1,
                    'StartDate', w2,
                    'EndDate', w2,
                    'CashCouponName', w0,
                    'CashCouponValueType', w3,
                    'CashCouponValue', w4,
                    'PartnerCompensatePc', w4,
                    'ProdImageLink', w5
                ]);
            }
        }
    }
}
